<template lang="pug">
#sidebar.noselect(:class='state' v-cloak)
  .top(:class='{ isAdmin }' @scroll='updateOpacity')
    .logo
      img(src='/img/logo-new.png' :style='{ opacity : logoOpacity }')
      h2 Course Catalog
    .links
      .link(
        v-for='route in routes'
        v-bind:to='route.path'
        router
        :class="{ 'router-link-active': $route.path === route.path }"
        @click='routeTo( route.path )'
      )
        .nameContainer
          h3 {{ route.name }}
          span.newInd(v-if="route.new") new
        .descContainer
          p {{ route.description }}
    .btns
      h1.header quick links
      .btns-wrapper
        a.floating-btn(:href='graduationRequirementsURL' target='_blank')
          p Graduation Requirements
          ChevIcon.icon-chevRight
        a.floating-btn(:href='courseEquivalencyURL' target='_blank')
          p Merced College Course Equivalency
          ChevIcon.icon-chevRight
        .floating-btn.chart-menu-toggle(:class='{ "icon-rotate" : chartMenuOpen }' @click='toggleChartMenu')
          p Course Progressions
          ChevIcon.icon-chevRight
        transition(name='slide')
          .menu#chart-menu(v-if='chartMenuOpen' ref='chartMenu')
            a.floating-btn.chart-menu-item(v-for='(item, i) in chartMenuItems' :key='`i-${name}`' :href="item.url" target="_blank")
              p {{ item.name }}
              ChevIcon.icon-chevRight
  .translate-container
    h1.header Change Language
    #google-translate-element
  .bottom
    .button(v-if='isAdmin' @click='openUpload') Upload
</template>

<script>
import FileUpload from '@/components/FileUpload';
import ChevIcon from '@/components/IconChevron';

export default {
  name       : 'sidebar',
  components : {
    FileUpload,
    ChevIcon,
  },

  data : () => ( {

    state          : 'open',
    showFileUpload : true,
    chartMenuOpen  : false,

    routes : [
      {
        name        : 'Available Courses',
        path        : '/courses',
        new         : false,
        description : 'Explore all course offerings.',

      },
      {
        name        : 'Career Technical Education',
        path        : '/cte',
        new         : false,
        description : 'Explore the pathways available to you.',
      },
      {
        name        : 'All Saved Courses',
        path        : '/saved',
        new         : false,
        description : 'Courses to save and view later.',
      },
      {
        name        : 'Program of Study',
        path        : '/program-of-study',
        new         : true,
        description : 'Explore MUHSD Programs of Study.'
      },
      {
        name        : 'Your Plan',
        path        : '/your-plan',
        new         : true,
        description : 'Make a plan to reach graduation!'
      }
    ],

    chartMenuItems : [
      {
        name : 'Math Progression 1',
        url  : 'https://firebasestorage.googleapis.com/v0/b/muhsd-course-catalog-dev-2278b.appspot.com/o/Math%20Progression%20-%20Part%201%20-%20June%207%202023.pdf?alt=media&token=656536b9-8b40-49e5-8267-a5b6ec405403',
      },
      {
        name : 'Math Progression 2',
        url  : 'https://firebasestorage.googleapis.com/v0/b/muhsd-course-catalog-dev-2278b.appspot.com/o/Math%20Progression%20-%20Part%202%20-%20June%207%202023.pdf?alt=media&token=a7d0bcf4-d3af-4e8c-9b57-60b72d7a4ffa',
      },
      {
        name : 'English Progression',
        url  : 'https://firebasestorage.googleapis.com/v0/b/muhsd-course-catalog-dev-2278b.appspot.com/o/English%20Progression%20MUHSD%202023%20-%2007%2027%2023.pdf?alt=media&token=d71aa6a3-0b41-4d14-9da1-49bd163f6af3',
      },
    ],

    logoOpacity : 1,

    graduationRequirementsURL : 'https://firebasestorage.googleapis.com/v0/b/muhsd-course-catalog.appspot.com/o/MUHSD%20Graduation%20Requirements%20Graphic%202024.pdf?alt=media&token=af700d7d-efa3-44ac-9e3f-b4ca078565d3',
    courseEquivalencyURL      : 'https://docs.google.com/viewer?url=https://docs.google.com/document/d/1t_v4v9ZTKkLzJsQvohGdOqMDK2xvlOt8rDp58uGOpbg/export?format=pdf',

    allowedExt : ['csv']
  } ),

  computed : {
    user() {
      return this.$store.state.user;
    },

    isAdmin() {
      return this.$store.state.isAdmin;
    },

    sideMenuSwiper() {
      return this.$store.state.sideMenuSwiper;
    },
  },

  methods : {
    toggleChartMenu() {
      this.chartMenuOpen = !this.chartMenuOpen;
    },
    toggleSlide() {
      this.$store.dispatch( 'toggleSideMenu' );
    },

    routeTo( route ) {
      this.$store.dispatch( 'closeCourseInfo' );
      this.$store.dispatch( 'closeSectorUpload' );
      this.$router.push( route ).catch( () => {} );
    },

    updateOpacity( e ) {
      this.logoOpacity = 1 - ( e.target.scrollTop / 85 );
    },

    openUpload() {
      this.$store.dispatch( 'updateStore', ['uploadOpened', true] );
    }
  },
};

</script>

<style lang="scss">
  @import '@/assets/variables.scss';

  #sidebar {
    background : $primary;
    width: 300px;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: auto;

    &::-webkit-scrollbar-thumb {
      height: 6px;
      border: 4px solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      -webkit-border-radius: 7px;
      background-color: white;
      -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
    }

    .handle {
      display: none;
    }

    &.closed {
      width: 60px;
      background-color: transparent;
    }

    .top {
      flex: 1 1 0;

      .logo {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        border-bottom: lighten( $primary, 15 ) solid 2px;

        img {
          width: 75px;
          height: 75px;
          border-radius: 100px;
        }

        h2 {
          margin-top: 10px;
          color: white;
        }

      }

      .links {
        display: flex;
        flex-direction: column;

        .link {
          color: white;
          padding: 20px;
          border-bottom: lighten( $primary, 15 ) solid 2px;
          cursor: pointer;

          &:hover {
            background-color: darken( $primary, 5 );
          }

          &.router-link-active {
            background-color: darken( $primary, 5 );
          }

          .nameContainer {
            display: flex;
            align-items: center;
            justify-content: space-between;

            h3 {
              pointer-events: none;
            }

            span {
              text-transform: uppercase;
              color: #90fbe1;
              font-family: 'Work Sans' sans-serif;
              font-style: italic;
            }
          }

          .descContainer {

            p {
              pointer-events: none;
              margin-top: 5px;
              font-weight: 300;
              font-size: 14px;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              color: white;
            }
          }
        }
      }

      .btns {
        margin-top: 30px;

        .header {
          color: white;
          font-size: 16px;
          text-transform: uppercase;
          letter-spacing: 3px;
          padding: 0 30px;
          text-align: center;
        }

        .btns-wrapper {
          margin-top: 10px;
          .floating-btn {
            padding: 10px 12px;
            text-align: center;
            background-color: transparent;
            cursor: pointer;
            text-transform: uppercase;
            font-weight: 600;
            display: inline-flex;
            align-items: center;
            width: 100%;
            text-decoration: none !important;
            transition: background-color 0.2s ease;
            border-radius: 4px;
            p {
              text-align: left;
              text-transform: capitalize;
              font-size: 14px;
              font-weight: 400;
            }

            &:hover {
              background-color: rgba(255, 255, 255, 0.1);
            }

            &:visited p,
            &:visited .icon-chevRight,
            p,
            .icon-chevRight {
              color: white;
            }
            .icon-chevRight {
              margin-left: auto;
              height: 10px;
              width: 10px;
            }
            &.chart-menu-toggle {
              .icon-chevRight {
                transition: transform 0.3s ease;
              }
              &.icon-rotate {
                .icon-chevRight {
                  transform: rotate(90deg) !important;
                }
              }
            }
          }
          #chart-menu {
            margin-bottom: 10px;
            background-color: #00000025;
            .chart-menu-item {
              padding: 10px 12px;
              text-align: center;
              background-color: transparent;
              cursor: pointer;
              text-transform: uppercase;
              font-weight: 500;
              display: inline-flex;
              align-items: center;
              width: 100%;
              text-decoration: none !important;
              transition: background-color 0.2s ease;
              border-radius: 4px;
              p {
                padding-left: 15px;
                text-align: left;
                text-transform: capitalize;
                font-size: 14px;
                font-weight: 400;
              }

              &:hover {
                background-color: rgba(255, 255, 255, 0.1);
              }

              &:visited p,
              &:visited .icon-chevRight,
              p,
              .icon-chevRight {
                color: white;
              }
              .icon-chevRight {
                margin-left: auto;
                height: 10px;
                width: 10px;
              }
            }
          }
        }
      }
    }

    .translate-container {
      h1 {
        color: white;
        font-size: 14px;
        text-transform: uppercase;
        letter-spacing: 5px;
        padding: 0 30px;
        text-align: center;
      }

      #google-translate-element {
        background: white;
        margin: 10px;
        border-radius: 5px;
        padding: 10px;
      }

      select {
        width: 100%;
        border: 1px solid $primaryAccent;
        padding: 5px;
        border-radius: 5px;
        color: $primaryAccent;
        cursor: pointer;
      }

      a {
        pointer-events : none;
      }
    }

    .bottom {
      .button {
        background-color: white;
        color: $primary;
        margin: 10px;
      }

      .file-upload {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;

        .drop-zone {
          background: #2f5491e6;
          box-shadow: $floatingObject;
        }
      }
    }
  }

  /* big and small phones */
  @media only screen and (min-width : 1px) and (max-width : 575px) {

    #sidebar {

      .top {
        padding-bottom: 0 !important;
      }

      .bottom {
        display: none;
      }
    }
  }

  @keyframes hoverEffectTop {
    from {
      transform: rotate(45deg);
    }
    50% {
      transform: rotate(0deg);
    }
    to{
      transform: rotate(45deg);
    }
  }

  @keyframes hoverEffectBottom {
    from {
      transform: rotate(-45deg);
    }
    50% {
      transform: rotate(0deg);
    }
    to{
      transform: rotate(-45deg);
    }
  }

  @media print {
    #sidebar {
      display: none;
    }
  }
  .slide-enter-active{
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-in;
    -webkit-transition-timing-function: ease-in;
    -o-transition-timing-function: ease-in;
    transition-timing-function: ease-in;
  }
  .slide-leave-active{
    -moz-transition-duration: 0.3s;
    -webkit-transition-duration: 0.3s;
    -o-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -moz-transition-timing-function: ease-out;
    -webkit-transition-timing-function: ease-out;
    -o-transition-timing-function: ease-out;
    transition-timing-function: ease-out;
  }
  .slide-enter-to, .slide-leave {
    max-height: 100px;
    overflow: hidden;
  }
  .slide-enter, .slide-leave-to {
    max-height: 0;
    overflow: hidden;
  }
</style>
